import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptCreateAccount = () => {
  return {
    event: GTMEvent.CREATE_ACCOUNT,
  }
}
